import { createClient, type SupabaseClient } from '@supabase/supabase-js'

/**
 * Supabase client for the Secretariat portal.
 *
 * The handoff's README is emphatic that the member app and this portal "must not
 * share a build, a login screen, or a token audience". This is a separate build
 * with its own login. The audience separation is enforced in the database: a
 * Secretariat account exists in `secretariat_users`, a member in `members`, a
 * trigger forbids one auth user from being in both, and every `admin_*` function
 * checks membership of `secretariat_users`. A member's token therefore cannot
 * reach anything on this portal's data path, whatever the client does.
 *
 * `storageKey` is distinct so that opening both products in one browser does not
 * have them overwrite each other's session in localStorage.
 */

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

export const isConfigured = Boolean(url && anonKey)

export const supabase: SupabaseClient = createClient(
  url ?? 'http://localhost:54321',
  anonKey ?? 'missing-anon-key',
  {
    auth: {
      storageKey: 'pan-secretariat-auth',
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: false,
    },
  },
)

export const configHint =
  'Create apps/admin/.env.local with VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.'
